var _path, _path2, _path3, _path4, _path5, _rect, _rect2, _path6, _path7, _path8, _path9, _path0, _rect3, _path1, _rect4, _rect5, _ellipse, _path10, _g, _g2, _path11, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVentilatorOffline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 246,
    viewBox: "0 0 115 246",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.856 233.587V224.621C74.856 223.517 73.9605 222.621 72.856 222.621H16.7079C15.6033 222.621 14.7079 223.517 14.7079 224.621V233.587",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4758 233.428V231.449C12.4758 230.029 11.3242 228.877 9.90366 228.877C8.48312 228.877 7.33154 230.029 7.33154 231.449V242.925C7.33154 244.345 8.48312 245.497 9.90366 245.497C11.3242 245.497 12.4758 244.345 12.4758 242.925V242.529C12.4758 241.108 13.6274 239.957 15.0479 239.957C16.4684 239.957 17.62 241.108 17.62 242.529V243.32C17.62 244.522 18.5944 245.497 19.7964 245.497C20.9984 245.497 21.9728 244.522 21.9728 243.32V231.053C21.9728 229.851 20.9984 228.877 19.7964 228.877C18.5944 228.877 17.62 229.851 17.62 231.053V233.428C17.62 234.848 16.4684 236 15.0479 236C13.6274 236 12.4758 234.848 12.4758 233.428Z",
    fill: "white",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6237 233.428V231.449C72.6237 230.029 71.4722 228.877 70.0516 228.877C68.6311 228.877 67.4795 230.029 67.4795 231.449V242.925C67.4795 244.345 68.6311 245.497 70.0516 245.497C71.4722 245.497 72.6237 244.345 72.6237 242.925V242.529C72.6237 241.108 73.7753 239.957 75.1959 239.957C76.6164 239.957 77.768 241.108 77.768 242.529V243.32C77.768 244.522 78.7424 245.497 79.9444 245.497C81.1464 245.497 82.1208 244.522 82.1208 243.32V231.053C82.1208 229.851 81.1464 228.877 79.9444 228.877C78.7424 228.877 77.768 229.851 77.768 231.053V233.428C77.768 234.848 76.6164 236 75.1959 236C73.7753 236 72.6237 234.848 72.6237 233.428Z",
    fill: "white",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3198 159.046L45.3198 218.564",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "square"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3198 76.0107L45.3198 94.2878",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "square"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20.4111,
    y: 35,
    width: 49.2999,
    height: 38.6399,
    rx: 3,
    stroke: "white",
    strokeWidth: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18.4111,
    y: 79.8877,
    width: 53.2999,
    height: 70.1782,
    rx: 5,
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0615 97.0247L59.8381 87.3619C60.0917 87.0657 60.7158 86.6733 61.1839 87.4729L62.3541 92.0822L65.0456 90.5273C65.4162 90.3792 66.1222 90.2941 65.9818 91.1382L64.5775 95.5253C64.3825 95.9326 63.8286 96.5027 63.1733 95.5253L62.3541 92.0822L51.9392 97.9688C51.5296 98.0614 50.7806 98.0021 51.0615 97.0247Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6338 54.9159H73.225C73.4127 54.9159 73.5846 54.8107 73.6701 54.6436L76.8198 48.4857C77.018 48.098 77.5826 48.1314 77.7338 48.5398L82.1103 60.3612C82.2449 60.7247 82.7239 60.8035 82.9678 60.5023L87.4919 54.9159",
    stroke: "black",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6338 49.1498H73.225C73.4127 49.1498 73.5846 49.0446 73.6701 48.8775L76.8198 42.7195C77.018 42.3319 77.5826 42.3653 77.7338 42.7736L82.1103 54.5951C82.2449 54.9586 82.7239 55.0374 82.9678 54.7362L87.4919 49.1498",
    stroke: "black",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0317 58.3956H46.1064C46.3156 58.3956 46.5027 58.2654 46.5753 58.0692L50.9832 46.163C51.1527 45.7052 51.8104 45.7367 51.9354 46.2086L56.6514 64.0147C56.774 64.4774 57.4142 64.52 57.5969 64.0774L62.4033 52.436C62.4805 52.2489 62.663 52.1268 62.8654 52.1268H73.2247C73.4125 52.1268 73.5844 52.0217 73.6699 51.8545L76.8195 45.6966C77.0178 45.309 77.5824 45.3424 77.7336 45.7507L82.1101 57.5722C82.2446 57.9356 82.7236 58.0144 82.9675 57.7133L87.4917 52.1268",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8398 147.979C83.2926 143.665 86.8715 137.124 86.438 133.07C86.2958 131.74 84.9535 131.062 83.6161 131.062H5.62857C3.99295 131.062 2.46328 132.061 2.28808 133.687C1.81493 138.079 3.7502 144.561 14.0042 147.979",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 151.424,
    width: 87,
    height: 5.6129,
    rx: 2.80645,
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0317 127.66H61.7414C62.2937 127.66 62.7414 128.107 62.7414 128.66V143.498C62.7414 144.051 62.2937 144.498 61.7414 144.498H15.0317V127.66Z",
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 50.7466,
    y: 172.563,
    width: 16.8387,
    height: 16.8387,
    rx: 3,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 24.0967,
    y: 175.37,
    width: 16.8387,
    height: 19.6452,
    rx: 3,
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.0641,
    cy: 136.079,
    rx: 5.6129,
    ry: 5.6129,
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2102 136.079C47.2102 138.351 45.3688 140.192 43.0973 140.192C40.8258 140.192 38.9844 138.351 38.9844 136.079C38.9844 133.808 40.8258 131.966 43.0973 131.966C45.3688 131.966 47.2102 133.808 47.2102 136.079Z",
    stroke: "white",
    strokeWidth: 3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_41_610)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_41_610)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 77.5,
    cy: 37.5,
    r: 22,
    fill: "#AD0606"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77.5,
    cy: 37.5,
    r: 20,
    stroke: "white",
    strokeWidth: 4
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_41_610)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_b_41_610)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 77.5,
    cy: 37.5,
    r: 24.5,
    stroke: "black",
    strokeWidth: 6
  })))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1741 27.0404C68.1006 26.9616 68.0121 26.8984 67.9137 26.8546C67.8153 26.8108 67.7091 26.7872 67.6014 26.7853C67.4937 26.7834 67.3867 26.8032 67.2868 26.8435C67.187 26.8839 67.0962 26.9439 67.0201 27.0201C66.9439 27.0962 66.8839 27.187 66.8435 27.2868C66.8032 27.3867 66.7834 27.4937 66.7853 27.6014C66.7872 27.7091 66.8108 27.8153 66.8546 27.9137C66.8984 28.0121 66.9616 28.1006 67.0404 28.1741L70.6381 31.7727C69.8519 32.2744 69.1229 32.8604 68.4639 33.5202C67.9398 34.0432 67.4329 34.6634 66.9731 35.3276C66.9114 35.4141 66.8676 35.512 66.8441 35.6156C66.8206 35.7192 66.8179 35.8264 66.8362 35.931C66.8545 36.0357 66.8934 36.1356 66.9506 36.2251C67.0079 36.3146 67.0823 36.3918 67.1696 36.4523C67.257 36.5128 67.3554 36.5553 67.4593 36.5775C67.5632 36.5996 67.6705 36.6008 67.7749 36.5812C67.8793 36.5615 67.9787 36.5213 68.0674 36.4629C68.1561 36.4044 68.2324 36.329 68.2917 36.2409C68.6991 35.6527 69.1472 35.1051 69.5986 34.6538C70.2591 33.9922 70.9999 33.4159 71.8037 32.9384L73.5063 34.641C72.7488 35.0434 72.0557 35.5567 71.4498 36.1639C70.7974 36.8162 70.2637 37.5541 69.8541 38.3626C69.7581 38.5525 69.7415 38.7728 69.8079 38.975C69.8743 39.1771 70.0182 39.3446 70.2081 39.4406C70.398 39.5367 70.6183 39.5533 70.8204 39.4869C71.0226 39.4205 71.1901 39.2766 71.2861 39.0867C71.6209 38.425 72.0592 37.821 72.5844 37.2975C73.1956 36.685 73.915 36.1912 74.7062 35.8409L76.7702 37.9049C75.605 38.0708 74.5254 38.6114 73.6945 39.4449C73.2149 39.929 72.8301 40.4984 72.5598 41.124C72.4745 41.3188 72.47 41.5396 72.5474 41.7378C72.6248 41.9359 72.7778 42.0952 72.9726 42.1806C73.1675 42.2659 73.3883 42.2704 73.5864 42.193C73.7846 42.1156 73.9439 41.9626 74.0293 41.7678C74.2271 41.3165 74.4966 40.9122 74.8281 40.5807C75.2902 40.1178 75.8627 39.7807 76.4916 39.6012C77.1205 39.4217 77.7848 39.4058 78.4215 39.5551L86.8241 47.9588C86.9753 48.105 87.1779 48.1859 87.3882 48.1842C87.5985 48.1824 87.7997 48.0982 87.9485 47.9495C88.0973 47.8009 88.1817 47.5998 88.1836 47.3895C88.1856 47.1792 88.1048 46.9765 87.9588 46.8252L68.1741 27.0404ZM77.0547 33.6517L78.7487 35.3457C80.1739 35.5915 81.4877 36.2734 82.5089 37.2975C83.0332 37.8302 83.4722 38.4405 83.8104 39.107C83.9102 39.2911 84.078 39.4288 84.2781 39.4908C84.4781 39.5528 84.6944 39.5341 84.8808 39.4388C85.0673 39.3434 85.209 39.1789 85.2758 38.9804C85.3425 38.7819 85.329 38.5652 85.2381 38.3766C84.8236 37.5607 84.2854 36.814 83.6425 36.1628C82.7841 35.3026 81.7532 34.6341 80.6177 34.2012C79.4822 33.7684 78.2679 33.5811 77.0547 33.6517ZM73.7426 30.3397L75.0538 31.6497C77.2348 31.1599 79.5127 31.3361 81.5925 32.1554C83.6723 32.9747 85.4583 34.3994 86.7193 36.2451C86.8401 36.4203 87.0256 36.5403 87.2349 36.5787C87.4441 36.6171 87.6601 36.5708 87.8353 36.4499C88.0104 36.3291 88.1304 36.1437 88.1688 35.9344C88.2072 35.7251 88.1609 35.5091 88.0401 35.334C86.5009 33.0857 84.2834 31.3884 81.7112 30.4899C79.139 29.5914 76.3469 29.5388 73.7426 30.3397ZM78.6332 42.2469C78.7822 42.3958 78.9004 42.5726 78.9811 42.7673C79.0618 42.9619 79.1033 43.1705 79.1034 43.3812C79.1034 43.5919 79.062 43.8005 78.9814 43.9951C78.9008 44.1898 78.7827 44.3667 78.6338 44.5157C78.4848 44.6647 78.308 44.7829 78.1134 44.8636C77.9187 44.9443 77.7101 44.9858 77.4994 44.9859C77.2888 44.9859 77.0801 44.9445 76.8855 44.8639C76.6908 44.7833 76.5139 44.6652 76.3649 44.5162C76.064 44.2154 75.8949 43.8074 75.8948 43.3819C75.8947 42.9564 76.0636 42.5483 76.3644 42.2474C76.6652 41.9465 77.0732 41.7774 77.4987 41.7772C77.9242 41.7771 78.3323 41.9461 78.6332 42.2469Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_41_610",
    x: 45.5,
    y: 5.5,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_41_610"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_41_610",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_41_610",
    x: 25.5,
    y: -14.5,
    width: 104,
    height: 104,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_41_610"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_41_610",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_41_610",
    x: 40,
    y: 0,
    width: 75,
    height: 75,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_41_610"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_41_610",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_b_41_610",
    x: 20,
    y: -20,
    width: 115,
    height: 115,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_41_610"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_41_610",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVentilatorOffline);
export default __webpack_public_path__ + "static/media/ventilator-offline.ef4a91c182d19200356acb30da45842e.svg";
export { ForwardRef as ReactComponent };